<template>
    <a  data-toggle="modal" @click="copyData" :class="[options.class, 'copy-icon-link']"
      :data-target="options.target">
      <i class="ag-icon ag-icon_copy_icon pl-2 ml-2 mr-2" data-toggle="tooltip" title="Copy" style="width: 25px !important; height: 24px !important;"></i>
    </a>
  </template>
  
  <script setup>
  import { defineEmits, defineProps } from "vue";
  
  const emit = defineEmits(['copyClick'])
  
  const props = defineProps({
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  })
  
  function copyData() {
    emit('copyClick', props.data)
  }
  </script>
  <style scoped>
  .copy-icon-link {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s ease, transform 0.2s ease;
  }
  .copy-icon-link:hover {
    transform: translateY(-1px);
  }
  .copy-icon-link:active {
    transform: translateY(0);
  }
  .copy-icon-link .ag-icon {
    transition: color 0.2s ease, filter 0.2s ease;
  }
  .copy-icon-link:hover .ag-icon {
    color: #2f6f99;
    filter: brightness(0.9);
  }
  </style>